import * as React from "react"
import { Link } from "gatsby"
import { Loadable } from "@loadable/component"
import { MdExpandMore } from "react-icons/md"
import * as styles from "./styles/dropdown.css"
import { IDropdownItemLink } from "./menus"

export default function Dropdown({ name, menu: MenuComponent }: DropdownProps) {
  const [open, setOpen] = React.useState(false)
  const menuRef = React.useRef<HTMLDivElement>(null)
  const [menuStyle, setMenuStyle] = React.useState({})

  React.useEffect(() => {
    if (!open) return setMenuStyle({})
    if (!menuRef.current) return
    const menuRect = menuRef.current.getBoundingClientRect()

    if (menuRect.right > window.innerWidth) {
      const diff = menuRect.right - window.innerWidth + 64
      setMenuStyle({
        left: -diff,
      })
    }
  }, [open])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setOpen(!open)
  }

  return (
    <div
      className={styles.root}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      <React.Fragment>
        <button className={styles.navItem} onClick={toggle}>
          {name}
          <MdExpandMore className={styles.navItemChevron} />
          {open && <span className={styles.arrow}></span>}
        </button>
        {open && (
          <div ref={menuRef} className={styles.menu} style={menuStyle}>
            <MenuComponent />
          </div>
        )}
      </React.Fragment>
    </div>
  )
}

export interface DropdownProps {
  name: string
  menu: Loadable<unknown>
}
